// extracted by mini-css-extract-plugin
export var marginNegative = "_5d-5 _5d-3 _5d-1";
export var marginPositive = "_5d-4 _5d-3 _5d-1";
export var modalContent = "_5d-6";
export var samplesTable = "_5d-8";
export var samplesTableContainer = "_5d-7";
export var statBox = "_5d-a";
export var tableCell = "_5d-1";
export var tableCellCenter = "_5d-2 _5d-1";
export var tableCellRight = "_5d-3 _5d-1";
export var tableHeader = "_5d-0";
export var trackingNumber = "_5d-9";